import { StateMap } from 'state-machines/PersonalLoanStateMachine';

export const sidebarStateLogic = (currentState) => {
  let calculatedStateMap = {
    BASIC_INFO: {
      active: true,
      complete: false,
    },
    SELECT_OFFER: {
      active: false,
      complete: false,
    },
    ADDITIONAL_INFO: {
      active: false,
      complete: false,
    },
    VERIFY_IDENTITY: {
      active: false,
      complete: false,
    },
    INCOME: {
      active: false,
      complete: false,
    },
    DOCUMENTS: {
      active: false,
      complete: false,
    },
    CSA: {
      active: false,
      complete: false,
    },
  };

  switch (currentState) {
    case StateMap.OFFER_SELECTION:
      calculatedStateMap = {
        ...calculatedStateMap,
        BASIC_INFO: {
          active: true,
          complete: true,
        },
        SELECT_OFFER: {
          active: true,
          complete: false,
        },
      };
      break;
    case StateMap.ADDITIONAL_INFO:
    case StateMap.SIGN_APP_SUMMARY:
      calculatedStateMap = {
        ...calculatedStateMap,
        BASIC_INFO: {
          active: true,
          complete: true,
        },
        SELECT_OFFER: {
          active: true,
          complete: true,
        },
        ADDITIONAL_INFO: {
          active: true,
          complete: false,
        },
      };
      break;
    case StateMap.ID_UPLOAD:
      calculatedStateMap = {
        ...calculatedStateMap,
        BASIC_INFO: {
          active: true,
          complete: true,
        },
        SELECT_OFFER: {
          active: true,
          complete: true,
        },
        ADDITIONAL_INFO: {
          active: true,
          complete: true,
        },
        VERIFY_IDENTITY: {
          active: true,
          complete: false,
        },
      };
      break;
    case StateMap.INCOME_VERIFICATION:
    case StateMap.SET_UP_DISBURSEMENT:
    case StateMap.EMPLOYER_VERIFICATION:
    case StateMap.MANUAL_PAYSTUB_UPLOAD:
    case StateMap.SET_UP_AUTOPAY:
      calculatedStateMap = {
        ...calculatedStateMap,
        BASIC_INFO: {
          active: true,
          complete: true,
        },
        SELECT_OFFER: {
          active: true,
          complete: true,
        },
        ADDITIONAL_INFO: {
          active: true,
          complete: true,
        },
        VERIFY_IDENTITY: {
          active: true,
          complete: true,
        },
        INCOME: {
          active: true,
          complete: false,
        },
      };
      break;
    case StateMap.REVIEW_DOCS:
      calculatedStateMap = {
        ...calculatedStateMap,
        BASIC_INFO: {
          active: true,
          complete: true,
        },
        SELECT_OFFER: {
          active: true,
          complete: true,
        },
        ADDITIONAL_INFO: {
          active: true,
          complete: true,
        },
        VERIFY_IDENTITY: {
          active: true,
          complete: true,
        },
        INCOME: {
          active: true,
          complete: true,
        },
        DOCUMENTS: {
          active: true,
          complete: false,
        },
      };
      break;
    case StateMap.TALK_TO_CSA:
    case StateMap.APP_REVIEW:
      calculatedStateMap = {
        ...calculatedStateMap,
        BASIC_INFO: {
          active: true,
          complete: true,
        },
        SELECT_OFFER: {
          active: true,
          complete: true,
        },
        ADDITIONAL_INFO: {
          active: true,
          complete: true,
        },
        VERIFY_IDENTITY: {
          active: true,
          complete: true,
        },
        INCOME: {
          active: true,
          complete: true,
        },
        DOCUMENTS: {
          active: true,
          complete: true,
        },
        CSA: {
          active: true,
          complete: false,
        },
      };
      break;
    case StateMap.COMPLETE:
      calculatedStateMap = {
        ...calculatedStateMap,
        BASIC_INFO: {
          active: true,
          complete: true,
        },
        SELECT_OFFER: {
          active: true,
          complete: true,
        },
        ADDITIONAL_INFO: {
          active: true,
          complete: true,
        },
        VERIFY_IDENTITY: {
          active: true,
          complete: true,
        },
        INCOME: {
          active: true,
          complete: true,
        },
        DOCUMENTS: {
          active: true,
          complete: true,
        },
        CSA: {
          active: true,
          complete: true,
        },
      };
      break;
    default:
      break;
  }

  return calculatedStateMap;
};
